import React from 'react';

import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import configs from '../../config/news.json';
import WebLayout from '../../layouts/WebLayout';
import NewEdmLayout from '../../layouts/NewEdmLayout'
import PageNotFound from '../../modules/common/PageNotFound'

import NewsListPanel from './NewsListPanel';
import NewsContent from './NewsContent';
import NewsNotification from './NewsNotification';
import EnforcementNewsListPanel from './EnforcementNewsListPanel';



function NewsRoute(props) {
    
    const { i18n } = useTranslation();
    const { match } = props;

    const toList = (props) => {        
        const { params } = props.match;

        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== null) {
            i18n.setDefaultNamespace('news');

            if ("enforcement" === cfg.category) {
                return (
                    <WebLayout component={EnforcementNewsListPanel} category={cfg.category}
                        sectionId={cfg.sectionId} pageId={cfg.pageId}/>
                );
            } else {
                return (
                    <WebLayout component={NewsListPanel} category={cfg.category}
                        sectionId={cfg.sectionId} pageId={cfg.pageId}/>
                );
            }
        } else {
            return (<PageNotFound/>);
        }
    };

    const toContent = (props) => {        
        const { params } = props.match;
        
        let cfg = null;
        if (params.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === params.urlPath);
        }

        if (cfg !== undefined) {
            const params = new URLSearchParams(props.location.search);
            const refNo = params.get('refNo');

            i18n.setDefaultNamespace('news');

            return (
                <WebLayout component={NewsContent} refNo={refNo}
                    sectionId={cfg.sectionId} pageId={cfg.pageId}/>
            );
        } else {
            return (<PageNotFound/>);
        }
    };

    const toEdm = (props) => {
        const params = new URLSearchParams(props.location.search);
        const refNo = params.get('refNo');

        i18n.loadLanguages(['EN','TC'],(err)=>{});
        return (
            <NewEdmLayout component={NewsNotification} refNo={refNo}/>
        );
    };

    const downloadFile = (props, apiUrl) => {
        const { params: routerParams } = props.match;
        
        let cfg = null;
        if (routerParams.urlPath === undefined) {
            cfg = configs.find((item) => item.category === "all");
        } else {
            cfg = configs.find((item) => item.urlPath === routerParams.urlPath);
        }

        if (cfg !== undefined) {
            window.location = apiUrl;
        } else {
            return (<PageNotFound/>);
        }
    }

    const openAppendix = (props) => {
        const { params: routerParams } = props.match;
        const urlParams = new URLSearchParams(props.location.search);

        const apiParams = new URLSearchParams();
        apiParams.set("lang",routerParams.lang);
        apiParams.set("refNo",urlParams.get('refNo'));
        apiParams.set("appendix",urlParams.get('appendix'));

        const apiUrl = `${process.env['PUBLIC_URL']}/api/news/openAppendix?${apiParams}`;

        return downloadFile(props, apiUrl);
    };

    return (
        <Switch>
            <Route path={`${match.path}:urlPath*/doc`} 
                render={toContent}/>
            <Route path={`${match.path}:urlPath*/openAppendix`} 
                render={openAppendix}/>            
            <Route path={`${match.path}:urlPath*/`} 
                strict exact render={toList}/>
            <Route path={`${match.path}notification`}
                render={toEdm}/>
        </Switch>
    );
}

export default withRouter(NewsRoute);